import type { Contact } from "@/Domain/Contact";
import { EnumPersonJobStatus } from "@/Domain/EnumPersonJobStatus";
import type { Changeset } from "@/Domain/Changeset";
import type { API } from ".";
import type { AddOrModifyContactRequest } from "@/Models/Requests/AddOrModifyContactRequest";

export function CreateAddOrModifyContactRequest(
  userLogin: string,
  companyLogin: string,
  c: Contact
): API["AddOrModifyContact"]["request"] {
  return {
    CompanyLogin: companyLogin,
    ContactId: c.Id,
    Title: c.Title,
    FirstName: c.Firstname,
    LastName: c.Lastname,
    Voice: c.Voice,
    Fax: c.Fax ? c.Fax : "",
    Cell: c.Cell ? c.Cell : "",
    Email: c.Email,
    EnteredBy: c.Enteredby,
    ModifiedBy: c.Modifiedby ? c.Modifiedby : "",
    OtherInfo: c.Otherinfo ? c.Otherinfo : "",
  } as AddOrModifyContactRequest;
}

export function CreateEmptyContact(): Contact {
  return {
    Id: 0,
    Title: "",
    Firstname: "",
    Lastname: "",
    Voice: "",
    Fax: "",
    Email: "",
    Name: "",
    StatusAsString: "",
    hasFirst: false,
    hasLast: false,
    hasTitle: false,
    hasVoice: false,
    hasEmail: false,
    hasMulipleEmailAddresses: false,
    who: "",
    mailingName: "",
    pendingInfoTransactionComment: "",
    Changeset: {} as Changeset,
    Cell: "",
    Enteredby: "",
    Dateentered: new Date(),
    Modifiedby: "",
    Datemodified: new Date(),
    Active: 1,
    Otherinfo: "",
    Compid: 0,
    Status: EnumPersonJobStatus.Active,
    HomeVoice: "",
    HomeFax: "",
    HomeEmail: "",
    HomeCell: "",
    ValidFromTime: new Date(),
    ValidToTime: new Date(),
    ValidFromDate: new Date(),
    CsModifiedBy: "",
  };
}
